import React from 'react';
import { connect } from 'react-redux';
import ReactQueryParams from 'react-query-params';
import { LoadingPage } from './../../screens/loading';
import ErrorPage from './../auth/error';
import { install } from './../../actions/';

////////////////////
// Shopify directs the installer here first.
// - It sends the query params to the express API to validate it came from Shopify
// - And then sets up the store in the DB ready to accept the charge.
// - The express API (in the /app/functions folder) passes back the charge URL, which they're then redirected to.
// Flow described here: https://shopify.dev/apps/auth/oauth
////////////////////

class Install extends ReactQueryParams {

    state = {
        loading: true,
        error: false
    }

    componentDidMount() {
        install(this.queryParams)
        .then((res) => {
            if (res.error) {
                this.setState({
                    loading: false,
                    error: true
                });
            } else {
                window.top.location.href = res.charge_url;
            }
        })
        .catch((err) => console.log(err));
    }

    render() {
        let { loading } = this.state;
        if (loading) {
            return <LoadingPage shop=""/>;
        } else {
            return <ErrorPage title="Error installing!" message="Please go back to Shopify and try again."/>;
        }
    }
}

const mapStateToProps = state => {
    return state;
}
  
export default connect(
    mapStateToProps
)(Install);